import { getUserState } from '@carvana/core-auth';
import { datadogRum } from '@datadog/browser-rum';
import { getRequest, postRequest } from '../../services/DataService';
import { ASRIssue } from './types';

const baseUrl = process.env.CARVANA_API_HYDRA_BASE_URL;
const asrServiceBaseUrl = `${baseUrl}/customercare/aftersalerepair/api/v1`;
const rumAction = 'asr-api-call';

const ASRApi = {
  getASRIssueCategories: async () => {
    const key = 'issuecategories';
    try {
      datadogRum.addAction(rumAction, { type: 'start', key });
      const categories = await getRequest({
        url: `${asrServiceBaseUrl}/issuecategories`,
      });
      datadogRum.addAction(rumAction, { type: 'success', key });
      return categories?.content ?? [];
    } catch (exception) {
      datadogRum.addAction(rumAction, { type: 'error', key });
      return [];
    }
  },

  createASR: async (issue: ASRIssue) => {
    const key = 'createasr';
    try {
      datadogRum.addAction(rumAction, { type: 'start', key });
      const customerId = getUserState().user?.sub;
      const formData = new FormData();
      formData.append('customerId', customerId);
      formData.append('source', 'MyCars');
      formData.append('isCustomer', 'true');

      const { category, location, type, details = '', images } = issue;
      formData.append(`issues[0][category]`, category);
      formData.append(`issues[0][location]`, location);
      formData.append(`issues[0][type]`, type);
      formData.append(`issues[0][details]`, details);
      images.forEach((image: any) => {
        formData.append(`issues[0].media`, image);
      });

      const asrStatus = await postRequest({
        url: asrServiceBaseUrl,
        data: formData,
        options: { timeout: 0 },
      });

      datadogRum.addAction(rumAction, { type: 'success', key });
      return asrStatus;
    } catch (exception) {
      datadogRum.addAction(rumAction, { type: 'error', key });
      return null;
    }
  },
};

export default ASRApi;
